"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodySkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const side_panel_1 = require("@alfalab/core-components/side-panel");
const skeleton_1 = require("@alfalab/core-components/skeleton");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.BodySkeleton>
 *
 * Скелетон, который должен использоваться вместо <SidePanel.Body>.
 */
const BodySkeleton = ({ CoreSidePanel = side_panel_1.SidePanel.Content, dataTestId, }) => {
    const skeleton = [0, 1, 2, 3, 4, 5].map((item) => ((0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { className: index_module_css_1.default.skeleton, visible: true }, item)));
    const contentProps = {
        className: index_module_css_1.default.component,
        dataTestId,
    };
    return (0, jsx_runtime_1.jsx)(CoreSidePanel, Object.assign({}, contentProps, { children: skeleton }));
};
exports.BodySkeleton = BodySkeleton;
